import './RunSelectionBanner.scss';
import { runLabel } from '../run-utils';
import { DataQaRun } from '../useForecastDataQa';
import { RunSelector } from './RunSelector';

interface RunSelectionBannerProps {
  runs: DataQaRun[];
  selectedS3Key: string;
  dateRange: { start: string; end: string };
  /** Combinations for the detail line — the full run or a scope-narrowed subset, per caller. */
  combinationsCount: number;
  onSelectRun: (s3Key: string) => void;
  onRefresh?: () => void;
  isRefreshing?: boolean;
  /** Optional lead-in label (e.g. "Data QA run"). */
  label?: string;
  testId?: string;
}

const dataQaRunKey = (run: DataQaRun) => run.s3Key;

// The run selection banner shared by the Request Forecast form and the Data QA
// audit table: a RunSelector plus the "· start → end · N combinations analyzed"
// detail. Owning the detail formatting here keeps the two pages from drifting apart.
export const RunSelectionBanner = ({
  runs,
  selectedS3Key,
  dateRange,
  combinationsCount,
  onSelectRun,
  onRefresh,
  isRefreshing,
  label,
  testId
}: RunSelectionBannerProps) => (
  <div className='run-selection-banner' data-testid={testId}>
    {label && <span className='run-selection-banner-label'>{label}</span>}
    <RunSelector
      runs={runs}
      runKey={dataQaRunKey}
      formatLabel={runLabel}
      selectedKey={selectedS3Key}
      onSelectRun={onSelectRun}
      onRefresh={onRefresh}
      isRefreshing={isRefreshing}
    />
    <span className='run-selection-banner-detail'>
      · {dateRange.start} → {dateRange.end} · {combinationsCount} combinations analyzed
    </span>
  </div>
);
